import { ContentSwitcher } from "./ContentSwitcher";
import { useAuthContext } from "../../hooks";

export function ContentSwitcherContainer() {
  const { user, isLoading } = useAuthContext();

  if (isLoading || user == null) {
    return null;
  }

  return <ContentSwitcher />;
}
